<span class="relative flex flex-col w-full h-full">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'label_register_external_employee' | translate }}</div>
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button (click)="close()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="white-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>
    <form [formGroup]="form" #ngForm="ngForm">
        <div class="p-6" mat-dialog-content>
            <ng-container>
                <div class="grid sm:grid-cols-4 gap-6 w-full">
                    <div class="sm:col-span-4">
                        <public-registry-search
                            label="{{ 'label_ssn' | translate }}"
                            (onOptionSelected)="optionSelected($event)"
                        ></public-registry-search>
                    </div>
                </div>
            </ng-container>
            <div class="float-left w-100 mt-2">
                <!-- Divider -->
                @if (form.get('agent')?.value) {
                <div class="mt-1 mb-1 border-t"></div>
                }
                <!-- Actions -->
                <div class="flex items-center justify-end mt-2 mb-2">
                    <button class="ml-1" (click)="addUser()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                        @if (formEnabled) {
                        <span> {{ 'label_register' | translate }} </span>
                        } @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                </div>
            </div>
        </div>
    </form>
</span>
